import {useEffect, useState} from 'react';

// Material-UI's Dialog always sets role="dialog" on its Paper (hardcoded in
// the library, independent of any JSS/class-name build config) — see
// node_modules/@material-ui/core/Dialog/Dialog.js. Popover/Menu/Select are
// built on the same underlying Modal primitive and would also match a
// body-overflow or aria-hidden check, but none of them render role="dialog",
// so this narrows detection to actual dialogs (the only overlay primitive
// this app uses — Drawer isn't used anywhere in the codebase).
const hasOpenDialog = () => Boolean(document.querySelector('[role="dialog"]'));

const useIsModalOpen = () => {
  const [isModalOpen, setIsModalOpen] = useState(hasOpenDialog);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsModalOpen(hasOpenDialog());
    });
    observer.observe(document.body, {childList: true, subtree: true});
    return () => observer.disconnect();
  }, []);

  return isModalOpen;
};

export default useIsModalOpen;
